import {
	checkIsActiveWarrantyFromDates,
	checkIsWarrantyActive,
	nullSafeGet,
} from './DataAccessUtils';

export const getActiveAssetWarrantySupplierId = (asset): number | null => {
	const warranty = nullSafeGet('warranties.0', asset);
	if (!checkIsWarrantyActive(warranty)) {
		return null;
	}
	return nullSafeGet('provider.supplierFacilityId', warranty) || null;
};

export const getActiveBuildingWarrantySupplierId = (location, problemTypeId): number | null => {
	if (!location) {
		return null;
	}

	const startDate = nullSafeGet('buildingWarrantyStartDate', location);
	const expirationDate = nullSafeGet('buildingWarrantyExpirationDate', location);
	if (!checkIsActiveWarrantyFromDates(startDate, expirationDate)) {
		return null;
	}

	const problemTypeIds = nullSafeGet('buildingWarrantyProblemTypeIds', location);
	if (problemTypeIds !== undefined && problemTypeIds !== null) {
		const matches = problemTypeIds.some((id) => id === problemTypeId);
		if (!matches) {
			return null;
		}
	}

	return nullSafeGet('buildingWarrantyServiceProviderId', location) || null;
};
